/** Maximum length of an e-mail address (RFC 5321). */
export const EMAIL_MAX_LENGTH = 254

/**
 * Linear-time shape check: `local@label.label`. The domain labels cannot contain
 * dots, so the pattern has a single way to match and cannot backtrack
 * quadratically (the old `[^\s@]+@[^\s@]+\.[^\s@]+` did, on input such as
 * `a@....... `).
 */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/

/** Trims and lowercases an e-mail. Returns an empty string for non-strings. */
export function normalizeEmail(value: unknown): string {
  return typeof value === 'string' ? value.trim().toLowerCase() : ''
}

/**
 * Returns true when the value looks like an e-mail. The length is checked first
 * so oversized input is rejected before any regular expression runs.
 */
export function isValidEmail(value: unknown): value is string {
  if (typeof value !== 'string') return false
  if (value.length === 0 || value.length > EMAIL_MAX_LENGTH) return false
  return EMAIL_PATTERN.test(value)
}
